// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_C5Q","cls2":"RelatedWorksCard-cls2_L5U RelatedWorksCard-cls1_C5Q"};